// SidebarPhase Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import PanelForm from '../../panel/panel_form/panel_form.jsx'
import FieldTitle from '../../form/field_title/field_title.jsx'
import FieldText from '../../form/field_text/field_text.jsx'
import FieldDate from '../../form/field_date/field_date.jsx'
import SidebarHeader from '../../layout/sidebar_header/sidebar_header.jsx'

class SidebarPhase extends Component {
  constructor (props) {
    super(props)

    this._phase = props.phase || null
    this.state = {
      dataDate: null
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func,
      onSave: PropTypes.func,
      phase: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      onClose: null,
      onSave: null,
      phase: null
    }
  }

  /* Event Handlers */
  _onChangeTab (tab) {
    this.setState({ currentTab: tab.ident })
  }

  _onChangeInput (name, value) {
    this._phase[name] = value
    this.setState({ dataDate: new Date() })
  }

  showEditTask (phase) {
    this._phase = phase
    this.setState({ dataDate: new Date() })
  }

  _onSaveInput (name) {
    const phase = this._phase
    if (this.props.onSave && phase) {
      const updateData = { [name]: phase[name] }
      this.props.onSave(phase.projectId, phase.phaseNo, updateData)
    }
  }

  _onChangeDate (fromDate, toDate) {
    const phase = this._phase
    phase.fromDate = fromDate
    phase.toDate = toDate

    this.setState({ dataDate: new Date() })

    if (this.props.onSave && phase) {
      const updateData = { fromDate: fromDate, toDate: toDate }
      this.props.onSave(phase.projectId, phase.phaseNo, updateData)
    }
  }

  /* Render functions */
  render () {
    const phase = this._phase
    if (!phase) {
      return null
    }

    return (
      <div className='sidebar-detail sidebar-phase'>
        {this._renderHeader()}
        <div className='sidebarcontent'>
          <div className='phasecontent'>
            <PanelForm className='panel-form panel-formphase'>
              <FieldTitle title='plannerv2.task.editTitle' />
              <FieldText
                name='title'
                value={phase.title}
                showEdit={false}
                onChange={this._onChangeInput.bind(this, 'title')}
                onSave={this._onSaveInput.bind(this, 'title')}
              />
              <FieldTitle
                classname='datetitle'
                title='plannerv2.task.gridHeaderDueDate'
              />
              <FieldDate
                name='dueDate'
                value={phase.fromDate}
                createdOn={phase.createdOn}
                startDate={phase.fromDate ? new Date(phase.fromDate) : null}
                endDate={phase.toDate ? new Date(phase.toDate) : null}
                onChange={this._onChangeDate.bind(this)}
              />
            </PanelForm>
          </div>
        </div>
      </div>
    )
  }

  _renderHeader () {
    const { onClose } = this.props
    const { currentTab } = this.state
    const tabs = [
      {
        ident: 'task',
        title: 'plannerv2.task.editHeaderTabPhase'
      },
      {
        ident: 'subtask',
        title: 'plannerv2.task.editHeaderTabActivity'
      }
    ]
    const actions = [
      {
        ident: 'edit',
        title: 'Edit',
        icon: 'edit'
      },
      {
        ident: 'edit',
        title: 'Edit',
        icon: 'edit'
      },
      {
        ident: 'edit',
        title: 'Edit',
        icon: 'edit'
      },
      {
        ident: 'edit',
        title: 'Edit',
        icon: 'edit'
      }
    ]

    return (
      <SidebarHeader
        title='plannerv2.task.editHeaderTitlePhase'
        subtitle='plannerv2.task.editHeaderSubtitle'
        icon='edit'
        tabs={tabs}
        actions={actions}
        onClose={onClose}
        activeTab={currentTab}
        onChangeTab={this._onChangeTab.bind(this)}
        showCloseBorder
      />
    )
  }
}

export default SidebarPhase
